import { render } from "./Payment-item.vue?vue&type=template&id=2cd349f9"
import script from "./Payment-item.vue?vue&type=script&lang=js"
export * from "./Payment-item.vue?vue&type=script&lang=js"

import exportComponent from "F:\\OneDrive\\Рабочий стол\\cleancutmeals\\cleancutmeals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__